import { z } from "zod";

export const pairedTransactionDataSchema = z.object({
    id: z.coerce.number(),
    amount: z.coerce.number().optional(),
    originalAmount: z.coerce.number().optional(),
    date: z.coerce.date().optional(),
    dateOnly: z.string().date().nullish(),
    bankDescription: z.string().optional(),
    displayDescription: z.string().nullish(),
    categoryId: z.string().optional(),
    entityId: z.coerce.number().optional(),
    financialAccountId: z.coerce.number().optional(),
});

export type PairedTransactionData = z.infer<typeof pairedTransactionDataSchema>;
